import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import App from "./App";
import { HashRouter } from "react-router";
import { createTheme, ThemeProvider } from "@mui/material";

const root = createRoot(document.getElementById("root"));
// Use https://zenoo.github.io/mui-theme-creator/ for theme generation
const muiTheme = createTheme({
  palette: {
    mode: "light",
    primary: {
      main: "#01216c",
    },
    secondary: {
      main: "#1b53c9",
    },
  },
  colorSchemes: {
    dark: true,
  },
  typography: {
    fontSize: 11,
  },
  components: {
    MuiTooltip: {
      styleOverrides: {
        tooltip: {
          fontSize: 14,
        },
      },
    },
  },
});

root.render(
  <StrictMode>
    <HashRouter>
      <ThemeProvider theme={muiTheme}>
        <App />
      </ThemeProvider>
    </HashRouter>
  </StrictMode>,
);
